import {Component, Input, Output, EventEmitter, OnChanges, SimpleChanges} from '@angular/core';

/**
 * Generated class for the TimeSelectBarComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'time-select-bar',
  templateUrl: 'time-select-bar.html'
})
export class TimeSelectBarComponent implements OnChanges{

  @Input() scopes = [];
  @Input() choosedIndex = 0;
  @Input() type;
  @Output() changeIndex = new EventEmitter();

  mark_length = 50;

  constructor() {
  }

  node_width;
  ngOnChanges(changes:SimpleChanges){
    if(changes['scopes'] && this.scopes){
      this.node_width = 100/this.scopes.length;
    }
    if(this.type == 'vip_bar'){
      this.mark_length = 64;
    }
  }

  changeScope(index){
    console.log(index);
    if(index != this.choosedIndex){
      this.choosedIndex = index;
      this.changeIndex.emit(this.choosedIndex);
    }
  }

}



// WEBPACK FOOTER //
// ./src/components/time-select-bar/time-select-bar.ts